import React, { Component } from "react";

import RoomBookSection from "./RB_sectionPrint";

class RB_RoomAreaPrint extends Component {
	state = {};
	render() {
		let { data, pageNumber } = this.props;
		let markUpData = [];
		let pageHeight = 1129;

		const currentPage = data[data.length - 1];
		if (currentPage == 1) {
			pageHeight = 944;
		}

		for (let i = 0; i < data.length; i++) {
			if (data[i].roomName) {
				markUpData.push(data[i]);
			}
		}
		// console.log(markUpData);

		return (
			<div className="RBuch-page">
				{markUpData.map((arr, id) => (
					<RoomBookSection data={arr} key={id} />
				))}
				<span className="RBuch-pageNumber ">
					{currentPage} / {pageNumber}
				</span>
			</div>
		);
	}
}

export default RB_RoomAreaPrint;
